import React, { useEffect, useState } from "react";
import { cloneCustomViewRequest, createCustomViewRequest, customViewRequest, customViewsRequest, deleteCustomViewRequest, updateCustomViewRequest } from "../../utils/request/api";
import saveView from "../../assets/svg/save_view.svg";
import cloneView from "../../assets/svg/clone_view.svg";
import createView from "../../assets/svg/create_view.svg";
import downRow from "../../assets/svg/down-fill.svg";
import loadingView from "../../assets/svg/load_view.svg";
import deleteView from "../../assets/svg/delete_view.svg";
import clearFilters from "../../assets/svg/clear_filters.svg";
import confirmed from "../../assets/svg/confirmed.svg";
import failed from "../../assets/svg/failed.svg";
import { Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";


const CustomViewsHandler = (
        {
            currentFilters,
            userId,
            setFilters,
            scope,
            loadingApplyFilters,
            reloadView,
            publicRef = null
        }
    ) => {

    const [newViewName, setNewViewName] = useState("");
    const [views, setViews] = useState(null);
    const [activeView, setActiveView] = useState(null);
    const [open, setOpen] = useState(false);
    const [show, setShow] = useState(false);
    const [loadingViews, setLoadingViews] = useState(false);
    const [loadingActivity, setLoadingActivity] = useState(false);
    const [message, setMessage] = useState(null);
    const [visible, setVisible] = useState(false);
    const [viewToDelete, setViewToDelete] = useState(null);
    const [viewToUpdate, setViewToUpdate] = useState(null);

    const fetchData = async () => {
        setLoadingViews(true);
        setOpen(false);
        const res = await customViewsRequest(userId, scope, 0, 10, setMessage);
        setViews(res.data?.content);
        setLoadingViews(false);
    }

    useEffect(() => {
        if (message) {
        setVisible(true);

        const timer = setTimeout(() => {
            setVisible(false);
        }, 5000);

        return () => clearTimeout(timer);
        }
    }, [message]);

    useEffect(() => {
        async function fetchInData() {
            setLoadingViews(true);
            setOpen(false);
            const res = await customViewsRequest(userId, scope, 0, 10);
            setViews(res.data?.content);
            setLoadingViews(false);
            document.getElementById("custom-view-name-input").value = "";
        }
        fetchInData();
    },[scope, userId])

    const createCV = async () => {
        setMessage(null);
        setLoadingActivity(true);
        document.getElementById("custom-view-name-input").value = "";
        await createCustomViewRequest(newViewName, scope, currentFilters, userId, setMessage);
        setLoadingActivity(false);
        setNewViewName("");
        fetchData();
    }

    const updateCV = async () => {
        setMessage(null);
        setLoadingActivity(true);
        await updateCustomViewRequest(newViewName, scope, currentFilters, userId, activeView.id, setMessage);
        const updatedView = await customViewRequest(userId, activeView.id);
        setActiveView(updatedView.data);
        setLoadingActivity(false);
        await fetchData();
    }

    const translateAndLoadView = (e) => {
        setActiveView(e);
        setNewViewName(e.name);
        document.getElementById("custom-view-name-input").value = e.name;
        if(publicRef){
            reloadView(true, JSON.parse(e.configValues));
        }else{
            reloadView(true, JSON.parse(e.configValues));
        }
        setMessage({text: "Solution configuration loaded", status: true});
    }

    const deleteCustomView = async () => {
        setMessage(null);
        setLoadingActivity(true);
        await deleteCustomViewRequest(userId, viewToDelete.id, setMessage);
        setLoadingActivity(false);
        await fetchData();
    };

    const cloneCustomView = async () => {
        setMessage(null);
        setLoadingActivity(true);
        await cloneCustomViewRequest(userId, activeView.id, setMessage);
        setLoadingActivity(false);
        await fetchData();
    };

    const clearCV = () => {
        setActiveView(null);
        setNewViewName("");
        document.getElementById("custom-view-name-input").value = "";
        setMessage({text: "Filters cleared", status: true});

        setFilters(prev => ({
            ...prev,
            [scope] : {
                filters: [],
                parameters: []
            }
        }));

        reloadView(false);
    }


    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        const formatted = `${day}-${month}-${year} / ${hours}:${minutes}`;

        return formatted;
    }

    const handleNewViewName = (e) => {

        if(e.length === 0){
            setNewViewName("");
            return;
        }

        const formatted =
        e.charAt(0).toUpperCase() + e.slice(1);

        setNewViewName(formatted);
    };

    return (
        <>
        <div className={`custom-views ${show ? "show" : ""}`}>
            <div className="custom-views__new">
                <input className="custom-views__new__input" maxLength={150} id="custom-view-name-input" placeholder="New solution configuration name..." onInput={(e) => handleNewViewName(e.target.value)} />
                <OverlayTrigger
                    overlay={
                        <Tooltip className="tooltipLi">
                            {
                                loadingActivity ?
                                <i>Loading...</i>
                                :
                                !activeView ?
                                <i>No solution configuration selected</i>
                                :
                                <b>Clone solution configuration</b>
                            }
                        </Tooltip>
                    }
                    placement="left"
                    className="overlayLi"
                >
                    <button className="custom-views__action" disabled={loadingActivity || !activeView} onClick={() => cloneCustomView()}>
                        <img src={cloneView} alt="Clone" />
                    </button>
                </OverlayTrigger>
                <OverlayTrigger
                    overlay={
                        <Tooltip className="tooltipLi">
                            {
                                loadingActivity ?
                                <i>Loading...</i>
                                :
                                !activeView ?
                                <i>No solution configuration selected</i>
                                :
                                newViewName.length === 0 ?
                                <i>There is no name for the solution configuration</i>
                                :
                                <b>Save solution configuration filters</b>
                            }
                        </Tooltip>
                    }
                    placement="left"
                    className="overlayLi"
                >
                    <button className="custom-views__action" disabled={loadingActivity || !activeView || newViewName.length === 0} onClick={() => setViewToUpdate(activeView)}>
                        <img src={saveView} alt="Save" />
                    </button>
                </OverlayTrigger>
                <OverlayTrigger
                    overlay={
                        <Tooltip className="tooltipLi">    
                            {
                                loadingActivity ?
                                <i>Loading...</i>
                                :
                                <>
                                {
                                    (newViewName.length !== 0 && currentFilters.length !== 0 && activeView?.name !== newViewName) ? 
                                    <b>Create new solution configuration</b>
                                    :
                                    <>
                                    {
                                        [   
                                            newViewName.length === 0 && "There is no name for a solution configuration;",
                                            currentFilters.length === 0 && "There are no active filters for a solution configuration;",
                                            activeView?.name === newViewName && "Change name for create a solution configuration;"
                                        ].filter(Boolean).map((e, i) => i > 0 ? <div className="p-0 m-0" key={"create"+i}><i >{e}</i></div> : <i key={"create"+i}>{e}</i>)
                                    }
                                    </>
                                }
                                </>
                            }
                        </Tooltip>
                    }
                    placement="left"
                    className="overlayLi"
                >
                    <button className="custom-views__action" disabled={loadingActivity || newViewName.length === 0 || currentFilters.length === 0 || activeView?.name === newViewName} onClick={() => createCV()}>
                        <img src={createView} alt="Create" />
                    </button>
                </OverlayTrigger>
            </div>
            <div className="custom-views__selector">
                <button
                    onClick={() => setOpen(!open)}
                    className="custom-views__selector__input"
                    disabled={loadingViews || !views || views.length === 0}
                    style={{borderBottomLeftRadius: open ? 0 : "10px", borderBottomRightRadius: open ? 0 : "10px"}}
                >
                    {
                        loadingViews ?
                        <Spinner animation="border" size="sm" className="me-2 mt-1 mb-1 spinner" />
                        :
                        !views || views.length === 0 ?
                        <i className="m-auto">No solution configurations available</i>
                        :
                        <>
                        <img src={downRow} alt="Down" style={{rotate: open && "180deg"}} />
                        <b>{ activeView ? activeView.name : "Select solution configuration"}</b>
                        <img src={downRow} alt="Down" style={{rotate: open && "180deg"}} />
                        </>
                    }
                </button>
                {open && (
                    <div className="custom-views__selector__items">
                    {views.map((view) => (
                        <div
                            key={view.id}
                            style={{
                                padding: "10px"
                            }}
                            className="custom-views__selector__item"
                        >
                            <div className="custom-views__selector__item__text">
                                <div className="custom-views__selector__item__actions">
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip className="tooltipLi">Delete solution configuration</Tooltip>
                                        }
                                        placement="left"
                                        className="overlayLi"
                                    >
                                        <button disabled={loadingActivity} onClick={() => setViewToDelete({name: view.name, id: view.id})}>
                                            <img src={deleteView} alt="Delete" />
                                        </button>
                                    </OverlayTrigger>
                                </div>
                                <p>{view.name}</p>
                                <i>{formatDate(view.lastModifiedDate)}</i>
                            </div>
                            <div disabled={activeView?.id === view.id} className="custom-views__selector__item__actions">
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip className="tooltipLi">
                                            {
                                                activeView?.id === view.id ?
                                                <i>Already loaded.</i>
                                                :
                                                <b>Load solution configuration</b>
                                            }        
                                        </Tooltip>
                                    }
                                    placement="left"
                                    className="overlayLi"
                                >
                                    <button disabled={loadingActivity} onClick={() => {
                                        setOpen(false);
                                        loadingApplyFilters?.(true);
                                        translateAndLoadView(view);
                                    }}>
                                        <img src={loadingView} alt="Load" />
                                    </button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    ))}
                    </div>
                )}
            </div>
            <div className="custom-views__external-actions">
                <OverlayTrigger
                    overlay={
                        <Tooltip className="tooltipLi">
                            {
                                loadingActivity ?
                                <i>Loading...</i>
                                :
                                <i>Reset dashboard</i>
                            }
                        </Tooltip>
                    }
                    placement="left"
                    className="overlayLi"
                >
                    <button disabled={loadingActivity} className="custom-views__external-actions__clear" onClick={() => clearCV()} style={{marginRight: "10px"}}>
                        <img src={clearFilters} alt="Clear" />
                    </button>  
                </OverlayTrigger> 
                <button className="custom-views__external-actions__show" style={{rotate: show && "180deg"}} onClick={() => setShow(!show)}>
                    <img src={downRow} alt="Down" style={{marginTop: "-3px"}} />
                </button>
            </div>
        </div>
        <div className={`custom-views__message ${visible ? 'show' : ''}`}>
            <b className="px-2">{message?.text}</b>
            <img src={message?.status ? confirmed : failed} alt="Status" width={25} height={25} style={{paddingRight: "5px"}} />
        </div>
        <Modal
            show={viewToDelete !== null}
            onHide={() => setViewToDelete(null)}
            centered
            backdrop="static"
            className="custom-views__delete"
        >
            <Modal.Header closeButton>
            <Modal.Title>Delete Solution Configuration</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                Are you sure you want to delete the <b style={{color: "#F54562", fontWeight: 900}}>'{viewToDelete?.name}'</b> solution configuration?
                <br/><br/>
                The configuration will be lost and you won't be able to load it again.
            </Modal.Body>

            <Modal.Footer>
            <button
                className="modal_handle-button" 
                onClick={() => {
                    deleteCustomView();
                    setViewToDelete(null);
                }}
            >
                Delete
            </button>
            </Modal.Footer>
        </Modal>
        <Modal
            show={viewToUpdate !== null}
            onHide={() => setViewToUpdate(null)}
            centered
            backdrop="static"
            className="custom-views__delete"
        >
            <Modal.Header closeButton>
            <Modal.Title>Update Solution Configuration</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                Are you sure you want to update the <b style={{color: "#F54562", fontWeight: 900}}>'{viewToUpdate?.name}'</b> solution configuration?
                <br/><br/>
                The old configuration will be replaced by the new one with the current active filters.
            </Modal.Body>

            <Modal.Footer>
            <button
                className="modal_handle-button"
                onClick={() => {
                    updateCV();
                    setViewToUpdate(null);
                }}>
                Update
            </button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default CustomViewsHandler;
